import { Col, Container, Row } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import logo from "../assets/img/Logo.png";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/facebook.svg";
import navIcon3 from "../assets/img/github.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-item-center">
          <MailchimpForm />
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a href="https://www.linkedin.com/in/king-praise-2185b6209">
                <img src={navIcon1} alt="" />
              </a>
              <a href="https://www.facebook.com/king.praise.982">
                <img src={navIcon2} alt="" />
              </a>
              <a href="https://github.com/KingPraise">
                <img src={navIcon3} alt="" />
              </a>
            </div>
            <p> CopyRight 2022. All Right Reserver By King Praise</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
